module.exports = __webpack_public_path__ + "img/ic_visa_saved-card.02a945f.svg";